'use strict';

const {noMoreThan} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('sub-pentagons', function () {
    const [label, ratioInput] = this.addLabeledSlider('Sub-Pentagon Ratio: ', 1, 100, 50);

    const shape = new Shape(5, Point.origin(), 100);
    shape.scaleToFitWithin(this.width - this.pad * 2, this.width - this.pad * 2);
    shape.setAnchorPoint(new Point(this.pad, this.pad));

    shape.draw(this.ctx);

    const _updateRatio = () => {
        let ratio = parseInt(ratioInput.value, 10) / 100;
        label.innerText = ratio.toFixed(2);
        shape.setFractalProportion(ratio);
        let subShapes = shape.getProportionalSubShapes();

        this.wipe();
        shape.draw(this.ctx);
        subShapes.forEach((shape) => shape.draw(this.ctx));
    };
    const updateRatio = noMoreThan(_updateRatio, 100);

    ratioInput.addEventListener('input', updateRatio);

    updateRatio();
});


